/** @jsxImportSource @emotion/react */
import { COLUMN_SPACING, ROW_SPACING } from "../../forms/styles";
import { MODAL_SIZE } from "../../layout/modal/modalSize";
import ModalTitleHeader from "../../layout/modal/ModalTitleHeader";
import ModalView, { ModalContent } from "../../layout/modal/ModalView";
import { useDispatch, useSelector } from "react-redux";
import { IAppState } from "../../core/redux/IAppState";
import { getResource } from "../../language/resources/getResource";
import importGuestIcon from "../../assets/icons/save.svg";
import { doNothing } from "../../language/module";
import { Column, Row } from "../../layout/flexbox";
import * as Buttons from "../../forms/elements/buttons";
import { GuestHydrationErrorReport } from "./GuestHydrationErrorReport";
import { css } from "@emotion/react";
import { clearGuestHydrationErrorReportAction } from "./clearGuestHydrationErrorReportAction";


const GuestHydrationModal = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  ${COLUMN_SPACING};
`;

type Props = {
  onDismiss?: () => void;
};

export const HydrationReportModal = (props: Props) => {
  const dispatch = useDispatch();
  const resources = useSelector((state: IAppState) => state.locale);

  const clearReport = () => dispatch(clearGuestHydrationErrorReportAction())

  const onCloseReport = () => {
    clearReport(); 
    (props.onDismiss || doNothing)();
  }

  return (
    <ModalView
      onDismiss={onCloseReport}
      size={MODAL_SIZE.DYNAMIC}
      contentCss={GuestHydrationModal}
      disableClickoffDismissable={true}
    >
      <ModalTitleHeader
        resources={resources}
        onDismiss={onCloseReport}
        heading={getResource(
          resources,
          "REPORTS_GUEST_HYDRATION_ERRORS_MODAL_HEADER"
        )}
        icon={importGuestIcon}
      />
      <ModalContent>
        <Column rootCss={COLUMN_SPACING}>
          <GuestHydrationErrorReport/>

          <Row justifyContent='flex-end' rootCss={css`margin-top: 25px; margin-right: 50px;${ROW_SPACING}`}>
            <Buttons.BigNeutral
              type="submit"
              onClick={onCloseReport}
              title={getResource(
                resources,
                "REPORTS_GUEST_HYDRATION_ERRORS_CLOSE_TITLE"
              )}
            >
              {getResource(resources, "REPORTS_GUEST_HYDRATION_ERRORS_CLOSE")}
            </Buttons.BigNeutral>
          </Row>
        </Column>
      </ModalContent>
    </ModalView>
  );
};
